export default "__VITE_ASSET__CsEZ2RON__"